export const MASTER_READING = "Master Reading"

export const READING_SESSION = "Reading Session"

export const ASSIGN_MACHINE = "Assign Machine Reading"
export const MATCH_TICKETS = "Match Tickets"



export const MASTER_READING_PAGES = {
    TABLE: "table",
    MATCH_TICKETS: "match-tickets",
    AUDIT_LOG: "audit-log"
}

export const AUDIT_LOG_TITLE = "Audit Log"


// tooltip names
export const BACK = "Back to Menu"

export const MASTER_READING_FIELDS = [
    {id: 'machine', label: 'Machine', align: "left"},
    // {id: 'type', label: 'Type', align: "left"},
    // {id: 'game', label: 'Game', align: "left"},
    {id: 'prevIn', label: 'Prev In 1', align: "left"},
    {id: 'prevOut', label: 'Prev Out 1', align: "left"},
    {id: 'curIn', label: 'Current In 1', align: "left"},
    {id: 'curOut', label: 'Current Out 2', align: "left"},
    {id: 'inValue', label: 'Daily In', align: "right"},
    {id: 'outValue', label: 'Daily Out', align: "right"},
    {id: 'difference', label: 'Difference', align: "right"},
    {id: 'lifePay', label: 'Life Pay %', align: "right"},
    {id: 'lifeHold', label: 'Life Hold %', align: "right"},
]


export const MATCH_TICKETS_MACHINE_FIELDS = [
    {id: 'machine', label: 'Machine', align: "left"},
    {id: 'previousReadingTime', label: 'Previous Reading Time', align: "left"},
    {id: 'currentReadingTime', label: 'Current Reading Time', align: "left"},
    {id: 'readingOut', label: 'Reading Out', align: "left"},
    {id: 'ticketOut', label: 'Ticket Out', align: "left"},
    {id: 'diff', label: 'Difference', align: "left"},
]


export const MATCH_TICKETS_EMPLOYEE_FIELDS = [
    {id: 'employee', label: 'Employee', align: "left"},
    {id: 'ticketTime', label: 'Ticket Time', align: "left"},
    {id: 'ticketAmount', label: 'Ticket Amount', align: "left"},
]